// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__26q2r","card":"Cards_card__2IQGo","infected":"Cards_infected__1FSSP","recovered":"Cards_recovered__1RBSG","deaths":"Cards_deaths__2IfK9"};